/**
 * Authentication Service — JWT self-contained auth
 */

const TOKEN_KEY = 'trade_auth_token';
const USER_KEY = 'trade_auth_user';

let currentUser = null;

export const AuthService = {
    init: async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            updateUI(null);
            return;
        }
        try {
            const resp = await fetch('/api/auth/me', {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            if (resp.ok) {
                const user = await resp.json();
                currentUser = { profile: { name: user.email, email: user.email } };
            } else {
                localStorage.removeItem(TOKEN_KEY);
                currentUser = null;
            }
        } catch {
            currentUser = null;
        }
        updateUI(currentUser);
    },

    login: () => {
        showAuthModal('login');
    },

    logout: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        currentUser = null;
        updateUI(null);
    },

    getUser: () => currentUser,

    getToken: () => localStorage.getItem(TOKEN_KEY),
};

function showAuthModal(mode) {
    if (document.getElementById('auth-modal')) return;

    const overlay = document.createElement('div');
    overlay.id = 'auth-modal';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;z-index:10000;';

    const isLogin = mode === 'login';
    overlay.innerHTML = `
        <div style="background:#1e2030;border-radius:12px;padding:32px;width:340px;color:#e0e0e0;box-shadow:0 8px 32px rgba(0,0,0,0.4);">
            <h3 style="margin:0 0 20px;font-size:18px;">${isLogin ? 'Login' : 'Register'}</h3>
            <div id="auth-error" style="color:#ff6b6b;font-size:13px;margin-bottom:8px;display:none;"></div>
            <input id="auth-email" type="email" placeholder="Email" style="width:100%;padding:10px;margin-bottom:10px;border-radius:6px;border:1px solid #444;background:#2a2d40;color:#e0e0e0;box-sizing:border-box;">
            <input id="auth-password" type="password" placeholder="Password" style="width:100%;padding:10px;margin-bottom:16px;border-radius:6px;border:1px solid #444;background:#2a2d40;color:#e0e0e0;box-sizing:border-box;">
            <button id="auth-submit" style="width:100%;padding:10px;border-radius:6px;border:none;background:#58a6ff;color:#fff;font-weight:600;cursor:pointer;">${isLogin ? 'Login' : 'Register'}</button>
            <div style="text-align:center;margin-top:12px;font-size:13px;">
                <a href="#" id="auth-switch" style="color:#58a6ff;text-decoration:none;">${isLogin ? 'Create account' : 'Already have an account? Login'}</a>
            </div>
            <div style="text-align:center;margin-top:8px;">
                <a href="#" id="auth-close" style="color:#888;font-size:12px;text-decoration:none;">Cancel</a>
            </div>
        </div>
    `;

    document.body.appendChild(overlay);

    document.getElementById('auth-close').onclick = (e) => { e.preventDefault(); overlay.remove(); };
    overlay.onclick = (e) => { if (e.target === overlay) overlay.remove(); };

    document.getElementById('auth-switch').onclick = (e) => {
        e.preventDefault();
        overlay.remove();
        showAuthModal(isLogin ? 'register' : 'login');
    };

    document.getElementById('auth-submit').onclick = () => submitAuth(isLogin ? 'login' : 'register');
    document.getElementById('auth-password').onkeydown = (e) => {
        if (e.key === 'Enter') submitAuth(isLogin ? 'login' : 'register');
    };
}

async function submitAuth(mode) {
    const email = document.getElementById('auth-email').value.trim();
    const password = document.getElementById('auth-password').value;
    const errorEl = document.getElementById('auth-error');

    if (!email || !password) {
        errorEl.textContent = 'Email and password required';
        errorEl.style.display = 'block';
        return;
    }

    try {
        let resp;
        if (mode === 'login') {
            const form = new URLSearchParams();
            form.append('username', email);
            form.append('password', password);
            resp = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: form,
            });
        } else {
            resp = await fetch('/api/auth/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
        }

        if (!resp.ok) {
            const err = await resp.json();
            errorEl.textContent = err.detail || 'Authentication failed';
            errorEl.style.display = 'block';
            return;
        }

        const data = await resp.json();
        localStorage.setItem(TOKEN_KEY, data.access_token);
        currentUser = { profile: { name: data.email, email: data.email } };
        updateUI(currentUser);

        const modal = document.getElementById('auth-modal');
        if (modal) modal.remove();
    } catch (e) {
        errorEl.textContent = 'Connection error';
        errorEl.style.display = 'block';
    }
}

function updateUI(user) {
    const loginBtn = document.getElementById('auth-login-btn');
    const userDisplay = document.getElementById('auth-user-display');
    const userName = document.getElementById('auth-user-name');
    const logoutBtn = document.getElementById('auth-logout-btn');

    if (user) {
        if (loginBtn) loginBtn.classList.add('hidden');
        if (userDisplay) userDisplay.classList.remove('hidden');
        if (userName) userName.textContent = user.profile.name || 'User';
        if (logoutBtn) logoutBtn.onclick = () => AuthService.logout();
    } else {
        if (loginBtn) loginBtn.classList.remove('hidden');
        if (userDisplay) userDisplay.classList.add('hidden');
        if (userName) userName.textContent = '';
    }
}
